import React, { useContext } from "react";
import PropTypes from "prop-types";
import { Box } from "@mui/material";
import { CredsContext } from "./Contexts";
import "./styles/Status.css";

// projectInfo elements:
// name
// pm

function StatusReportHeader(props) {
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const creds = useContext(CredsContext).creds;
  const users = JSON.parse(localStorage.getItem(creds.company + "|User"));
  const pmRecord = users.find((elem) => elem.id == projectObject.userid);
  const pm = pmRecord.name;
  const reportDate = new Date().toLocaleString();

  return (
    <Box sx={{ textAlign: "left" }}>
      <div className="statusTableColumnHeader">
        {projectObject.customer_name}
      </div>
      <div className="statusTableCell" style={{ fontSize: "large" }}>
        {projectObject.name}
      </div>
      <div className="statusTableCell">
        {reportDate}
        <br></br>PM: {pm}
      </div>
    </Box>
  );
}

export default StatusReportHeader;

StatusReportHeader.propTypes = {
  projectInfo: PropTypes.object,
};
